<div class="text-center p-4">
  @if (product) {
    <h2>Subscribe to {{ product?.name }}</h2>
  }
  @if (price && currency) {
    <p>Price: {{ currency }} {{ price }}</p>
  }

  <div id="paypal-button-container" class="my-4"></div>
</div>

<!-- SUCCESS MODAL -->
<div class="modal fade" id="paymentModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0">

      <!-- HEADER -->
      <div class="modal-header bg-success text-white text-center border-0">
        <h4 class="modal-title w-100 fw-bold">
          Subscription Activated 🎉
        </h4>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <div class="alert alert-success text-center">
          <strong>
            Thank you, {{ paymentDetails?.subscriber?.name?.given_name || 'Subscriber' }}!
          </strong>
          <p class="mb-0">Your subscription is now active.</p>
        </div>

        <div class="bg-light p-3 rounded">

          <h6 class="fw-bold text-success mb-3">
            <i class="fas fa-receipt me-2"></i> Subscription Summary
          </h6>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Subscription ID:</span>
            <span class="fw-semibold">{{ paymentDetails?.id }}</span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Email:</span>
            <span class="fw-semibold">{{ paymentDetails?.subscriber?.email_address }}</span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Plan ID:</span>
            <span class="fw-semibold">{{ paymentDetails?.planId }}</span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Currency:</span>
            <span class="fw-semibold">
              {{ paymentDetails?.extractedCurrency }}
            </span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Amount Paid:</span>
            <span class="fw-semibold">
              ${{ paymentDetails?.extractedAmount }}
            </span>
          </div>

          <div class="d-flex justify-content-between py-2">
            <span class="text-muted">Status:</span>
            <span class="badge bg-success px-3 py-2">
              {{ paymentDetails?.status }}
            </span>
          </div>
        </div>
        <!-- Additional Information -->
        <div class="mt-4 text-center">
          <div class="alert alert-info border-0 bg-info-soft" role="alert">
            <div class="d-flex align-items-center justify-content-center">
              <i class="fas fa-envelope me-2"></i>
              <small class="text-muted">
                A detailed receipt has been sent to your number/email for your reference.
              </small>
            </div>
          </div>
        </div>

      </div>
      <!-- Footer -->
      <div class="modal-footer bg-light py-3 border-0">
        <button type="button" class="btn btn-success px-4 py-2 fw-semibold rounded-pill" data-bs-dismiss="modal">
          <i class="fas fa-thumbs-up me-2"></i>
          Continue
        </button>
      </div>
    </div>
  </div>
